import React, { Component } from 'react';
import { connect } from 'react-redux';
import ChildSettingsForm from './SettingsForm';
import { createChild, updateChild } from '../actions';
import { getChild, hasSameAsParentChild } from '../reducer';
import { withTranslation } from 'react-i18next';

class Details extends Component {

	constructor(props) {
		super(props);
		this.handleSameAsParentChange = this.handleSameAsParentChange.bind(this);
		this.handleChildSettingsSubmit = this.handleChildSettingsSubmit.bind(this);
		this.state = { sameAsParent: false };
	}

	componentWillReceiveProps(nextProps) {
		if (!this.propschild && nextProps.child) {
			this.setState({ sameAsParent: nextProps.child.sameAsParent });
		}
	}

	handleSameAsParentChange() {
		this.setState({ sameAsParent: !this.state.sameAsParent });
	}

	handleChildSettingsSubmit(values) {
		const { child, updateChild, createChild, history, enableParentSelfBooking, parent } = this.props;
		if (child) {
			updateChild(child.id, values, history);
		} else {
			createChild(values, history);
		}
	};

	render() {
		const { child, genderTypes, requireChildLastName, requireChildSchool, enableParentSelfBooking, hasSameAsParentChild, t } = this.props;

		return (
			<div>
				<h3>{t('FO_Child_PersonalDetails')}</h3>
				<ChildSettingsForm
					onSubmit={this.handleChildSettingsSubmit}
					initialValues={child}
					genderTypes={genderTypes}
					requireChildLastName={requireChildLastName}
					requireChildSchool={requireChildSchool}
					enableParentSelfBooking={enableParentSelfBooking}
					backPath='/children'
					sameAsParent={this.state.sameAsParent}
					sameAsParentChange={this.handleSameAsParentChange}
					hasSameAsParentChild={hasSameAsParentChild}
				/>
			</div>
		);
	}
};

const mapStateToProps = (state, ownProps) => {
	const { configuration: { franchisor } } = state;

	const child = getChild(state.parent, Number(ownProps.match.params.id));

	return {
		child: child ? child : { sameAsParent: 'false' },
		genderTypes: state.lookups.genderTypes,
		requireChildLastName: franchisor && franchisor.requireChildLastName,
		requireChildSchool: franchisor && franchisor.requireChildSchool,
		enableParentSelfBooking: franchisor && franchisor.enableParentSelfBooking,
		parent: state.parent,
		hasSameAsParentChild: hasSameAsParentChild(state.parent)
	};
};

export default connect(mapStateToProps, {
	createChild,
	updateChild
})(withTranslation()(Details));